import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, Injector, ChangeDetectionStrategy } from '@angular/core';
import { Admi10PkgComponent } from './admi10Pkg.component';
import { CrudbarComponent, MaterialModule } from 'jk-service';
import { JkBillFormComponent } from 'jk-advcom';

@Component({
  selector: 'app-admi10-bill',
  standalone: true,
  imports: [CommonModule,
    MaterialModule,
    CrudbarComponent,
    Admi10PkgComponent,
    //Admi10DetailComponent,
    ],
  templateUrl: './admi10BillPkg.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Admi10BillComponent extends JkBillFormComponent implements OnInit {
  override _programId = ' admi10'; //###
  override masterPage!:  Admi10PkgComponent;
  //override detailPage!:  Admi10DetailComponent;
  constructor() {
    super();
    this.setFormOpt2(); //###
  }


  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override doMasterPageReady($event: any) {
    super.doMasterPageReady($event);
  }
  // 以下客製 --------------------------------------------------------


}
